export default "__VITE_ASSET__7229652e__"